import { render, staticRenderFns } from "./Learners.vue?vue&type=template&id=1cbbd8c4"
import script from "./Learners.vue?vue&type=script&lang=js"
export * from "./Learners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports